module.exports = __webpack_public_path__ + "static/media/Bar chart.afc03830.svg";